import { toCapitalizeFirstLetter } from '@loadsmart/utils-string'

import { type Shipment } from '../domain/Shipment'

export function formatMileage(mileage?: number) {
  return mileage ? `${mileage} miles` : '-'
}

export function formatValue(value?: string) {
  return value ? value : '-'
}

export function formatTarp(shipment: Shipment) {
  const { tarpType, tarpSize } = shipment
  const tarp = []

  if (!tarpType && !tarpSize) {
    return '-'
  }

  if (tarpType) {
    tarp.push(toCapitalizeFirstLetter(tarpType))
  }

  if (tarpSize) {
    tarp.push(tarpSize)
  }

  return `${tarp.join(' • ')} feet`
}

export function formatSONumbers(shipment: Shipment) {
  const { soNumbers } = shipment

  if (!soNumbers || soNumbers.length === 0) {
    return '-'
  }

  return soNumbers.join(', ')
}

export function formatProNumber(proNumber?: string) {
  return proNumber || 'Pending'
}

export function formatTrailerNumber(shipment: Shipment) {
  const { trailerNumber } = shipment

  return trailerNumber ?? '-'
}

export function formatSealNumber(shipment: Shipment) {
  const { sealNumber } = shipment

  return sealNumber ?? '-'
}
